var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enabled)?_c('v-chip',{attrs:{"label":"","small":"","color":_vm.color,"text-color":"white"}},[_vm._v("Enabled")]):_c('v-chip',{attrs:{"label":"","small":"","color":_vm.color,"text-color":"white"}},[_vm._v("Disabled")])}
var staticRenderFns = []

export { render, staticRenderFns }